var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-lang"},[_c('router-link',{attrs:{"to":_vm.routeChanged},domProps:{"innerHTML":_vm._s(_vm.$store.state.lang === 'it' ? 'en' : 'it')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }